import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import baseAxios from 'src/utils/baseAxios';

export const GetProductTenantSales = createAsyncThunk(
  '/GetProductTenantSales',
  async () => {
    const response = await baseAxios.get(`/payment/productTenantSales`);
    return response.data;
  }
);

export const UpdateProductTenantSales = createAsyncThunk(
  '/UpdateProductTenantSales',
  async (data) => {
    const response = await baseAxios.post(`/payment/updateProductTenantSales`, {
      ProductTenantSalesId: data.Id,
      Price: data.Price,
      Active: data.IsActive
    });
    return response.data;
  }
);

const paymentSlice = createSlice({
  name: 'payment',
  initialState: {
    productTenantSales: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetProductTenantSales.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetProductTenantSales.fulfilled, (state, action) => {
        state.loading = false;
        state.productTenantSales = action.payload;
      })
      .addCase(GetProductTenantSales.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(UpdateProductTenantSales.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(UpdateProductTenantSales.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpdateProductTenantSales.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export const paymentActions = paymentSlice.actions;
export default paymentSlice;
